// This file is autogenerated. Any changes will be overwritten.

export const set = 'budicon';

export const name = 'diamond-minus';

export const Component = () => (
  <path
    fill='currentColor'
    fillRule='evenodd'
    d='M23.219 13.178a.96.96 0 0 0 0-1.356L13.179 1.78a.96.96 0 0 0-1.357 0L1.78 11.821a.96.96 0 0 0 0 1.357l10.04 10.041a.96.96 0 0 0 1.357 0l10.041-10.04ZM18 11.5H7v2h11v-2Z'
  />
);

export const viewBox = '0 0 25 25';
